import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {MatSelectModule} from '@angular/material/select';
import {  PatientListFilter } from './patient-list-filter.component';
import { DirectivesModule } from '../../directives/directive.module';
import { Filter } from './filter';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  declarations: [
    PatientListFilter
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    DirectivesModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule
  ],
  exports: [
    PatientListFilter
  ]
})
export class PatientListFilterModule { }
